import React from 'react'
import { Link } from 'react-router-dom'
import { AlertCircle, Lock } from 'lucide-react'
import './PaywallModal.css'

function PaywallModal({ isAdmin = false }) {
  return (
    <div className="paywall-overlay">
      <div className="paywall-modal">
        <div className="paywall-icon">
          <Lock size={48} />
        </div>
        
        <h2>Subscription Expired</h2>
        
        {isAdmin ? (
          <>
            <p>
              Your NeighborTopia subscription has expired. 
              Please renew it to restore access for your neighborhood.
            </p>
            <Link to="/admin?section=subscription" className="paywall-btn primary">
              Go to Admin → Subscription
            </Link>
          </>
        ) : (
          <>
            <p>
              Your NeighborTopia subscription has expired.
              Please contact your HOA board or neighborhood association board and ask them to renew it.
            </p>
          </>
        )}
        
        <div className="paywall-help">
          <AlertCircle size={16} />
          <span>
            Questions? Contact <a href="mailto:info@neighbortopia.app">info@neighbortopia.app</a>
          </span>
        </div>
      </div>
    </div>
  )
}

export default PaywallModal
